import { Dropdown } from "primereact/dropdown";
import * as React from "react";
import { OptionsConstants } from "../../../models/constants/options.constants";
import "./PrwCountryDropdown.scss";

const PrwCountryDropdown = (props: any) => {

  const IMG = (imgName: string) => {
    return require(`./../../../../../../../assets/icons/flags/${imgName}.svg`)?.default;
  };

  const selectedOptionTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div className="flex items-center">
          <img
            alt={option.name}
            src={IMG(option.code.toLowerCase())}
            className="w-5 mx-2 align-middle"
          />
          <div>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder || "dummy Value"}</span>;
  };

  const optionTemplate = (option: any) => {
    return (
      <div className="flex items-center">
        <img
          alt={option.name}
          src={IMG(option.code.toLowerCase())}
          className="w-5 mx-2 align-middle"
        />
        <div>{option.name}</div>
      </div>
    );
  };

  return (
    <div>
      <Dropdown
        className={`prw-country-dropdown p-inputtext-sm ${props?.rawErrors?.length > 0 ? 'p-invalid': null}`}
        value={props.value}
        options={OptionsConstants.Countries}
        optionLabel="name"
        optionValue="code"
        valueTemplate={selectedOptionTemplate}
        itemTemplate={optionTemplate}
        placeholder={""}
        filter
        showClear
        filterBy="name"
        onChange={(e) => {
          props.onChange(e.value);
        }}
      />
    </div>
  );
};

export default PrwCountryDropdown;
